import * as React from "react";
import { IDefaultViewProps } from "./IDefaultViewProps";
import { Caption } from "../../atoms/views/Caption";
import { ContactpersoonIcon } from "../../atoms/icons/ContactpersoonIcon";
import { Box, Typography } from "@material-ui/core";
import { IContactPerson } from "../../../store/client/clientItem";
import { useTranslation } from 'react-i18next';

// All the incoming values
interface IProps {
    value?: IContactPerson[] | null;
}

// Outgoing functions
interface IDispatch {
}

// Actual Component
export type AllProps = IProps & IDispatch & Omit<IDefaultViewProps<IContactPerson[] | null>, 'value'>;
export const ContactPersons = (props: AllProps) => {
    const { t: tClient } = useTranslation('client');

    const formatContactPersons = () => {
        if (!props.value || props.value.length === 0) {
            return '-';
        }

        return (
            <Box>
                {props.value.map((person, index) => {
                    const type = person.contactPersonTypeName || person.customTypeName || '';
                    const contactMethods: string[] = [];
                    if (person.phoneNumber) contactMethods.push(person.phoneNumber);
                    if (person.emailAddress) contactMethods.push(person.emailAddress);

                    return (
                        <Box key={person.id} mb={index < props.value!.length - 1 ? 1 : 0}>
                            <Typography variant="body2">
                                <strong>{person.name}</strong> {type && `(${type})`}
                            </Typography>
                            {contactMethods.length > 0 && (
                                <Typography variant="body2" color="textSecondary">
                                    {contactMethods.join(' • ')}
                                </Typography>
                            )}
                        </Box>
                    );
                })}
            </Box>
        );
    };

    const label = props.label || tClient('contactPersonsTitle') || "Contactpersonen";
    return (<Caption loading={props.loading} caption={label} icon={<ContactpersoonIcon />}>
        {formatContactPersons()}
    </Caption>)
}
